export default __webpack_public_path__ + "static/media/logo.f0564360.png";